import {Box} from '@mui/material';
import AppBreadcrumbs from '../../navigation/layout/Breadcrumbs';
import HelpLanguageSwitcher from './HelpLanguageSwitcher';

type HelpCrumbBarProps = {
  items: {label: string; path?: string}[];
};

/**
 * The top row of a help category or article: the breadcrumbs (the app's
 * own, with the help trail) on the left, the content-language switcher on
 * the right. Wraps under the crumbs on a phone.
 */
const HelpCrumbBar = ({items}: HelpCrumbBarProps) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: 2,
      rowGap: 1,
      mb: 2,
      '& .MuiBreadcrumbs-root': {mb: 0, minWidth: 0},
    }}>
    <AppBreadcrumbs customItems={items} />
    <Box sx={{ml: 'auto'}}>
      <HelpLanguageSwitcher />
    </Box>
  </Box>
);

export default HelpCrumbBar;
